import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../../../i18n/i18n'
import './quem-somos-painel.scss'

type Value = { h: string; p: string }

export function QuemSomosPainel() {
  const navigate = useNavigate()
  const { t } = useI18n()
  const values = t('sobre.values') as Value[]

  return (
    <div className="container__quem-somos-painel">
      <div className="hero__quem-somos">
        <h1>{t('sobre.heroTitle')}</h1>
        <p>{t('sobre.heroSub')}</p>
      </div>

      <div className="grid__quem-somos">
        <div className="text-content__quem-somos">
          <h2>{t('sobre.trajTitle')}</h2>
          <p>{t('sobre.traj1')}</p>
          <p>{t('sobre.traj2')}</p>
        </div>

        <div className="values__quem-somos">
          {values.map((v, i) => (
            <div className="value-card__quem-somos" key={i}>
              <h3>{v.h}</h3>
              <p>{v.p}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="cta__quem-somos">
        <h2>{t('sobre.ctaTitle')}</h2>
        <button onClick={() => navigate('/contato')}>{t('sobre.ctaButton')}</button>
      </div>
    </div>
  )
}
